import React from 'react';
import c from 'classnames';
import './style.scss';
var Accordion = function Accordion(props) {
  var className = props.className,
    children = props.children;
  var classes = c('Accordion', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, children);
};
export default Accordion;